<template>
  <article id="flying-through-space" class="post">
    <post-header v-bind:post="post"></post-header>
    <div class="body-text">
      <div id="space-simulation" :class="fullScreen ? 'maximized' : 'minimized'">
        <a v-if="fullScreen" id="button-minimize" @click="minimize">Minimize</a>
        <a v-else id="button-maximize" @click="maximize">Maximize</a>
      </div>
    </div>
  </article>
</template>

<script>
import * as d3 from 'd3';

import PostHeader from '../../post-sections/post-header.vue';
import Simulation from './js/simulation.js';

export default {
  name: 'flying-through-space',
  props: ['post'],
  components: {
    'post-header': PostHeader
  },
  data() {
    return {
      fullScreen: false
    };
  },
  mounted() {
    this.simulation = new Simulation('#space-simulation');

    d3.selectAll('#simulation')
      .selectAll('*')
      .attr(this.$options._scopeId, '');
  },
  methods: {
    maximize() {
      //   this.simulation.stop();
      this.fullScreen = true;
      this.simulation.updateSize();
    },
    minimize() {
      //   this.simulation.stop();
      this.fullScreen = false;
      this.simulation.updateSize();
    }
  }
};
</script>

<style scoped>
#space-simulation {
  position: relative;
  height: 60vh;
}

#button-maximize,
#button-minimize {
  font-size: 1rem;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  top: 10px;
  right: 10px;
  color: firebrick;
  z-index: 100;
}

#button-maximize {
  position: absolute;
}

#button-minimize {
  position: fixed;
}

a:hover {
  cursor: pointer;
}

#space-simulation.maximized {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  height: 100vh;

  z-index: 99;
}
</style>
